module.exports = __webpack_public_path__ + "img/calendar.82beccf2.svg";